import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import React from "react";

function CopyButton({ onclick }) {
  return (
    <button
      className="mr-3 text-teal-500 duration-300 ease-in-out hover:text-teal-900 "
      onClick={onclick}
    >
      <DocumentDuplicateIcon className="w-4 h-4" />
    </button>
  );
}

export default CopyButton;
